export interface HttpClientResponse<T> {
    data: T;
    blob?: Response;
    status: number;
}

class HttpClient<T> {
    private baseUrl: string;

    private headers: Record<string, string>;

    constructor(baseUrl: string, headers: Record<string, string> = {}) {
        this.baseUrl = baseUrl;
        this.headers = headers;
    }

    async get(path: string): Promise<HttpClientResponse<T>> {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'GET',
            headers: this.headers
        });
        let data = {} as T;
        try {
            data = await response.json();
        } catch (error) {
            // DO NOTHING
        }

        return {
            data,
            status: response.status
        };
    }

    async post(path: string, body: any): Promise<HttpClientResponse<T>> {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...this.headers
            },
            body: JSON.stringify(body)
        });

        let data = {} as T;
        try {
            data = await response.json();
        } catch (error) {
            // DO NOTHING
        }

        return {
            data,
            status: response.status
        };
    }

    async rawPost(path: string, body: any): Promise<HttpClientResponse<T>> {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'POST',
            headers: {
                ...this.headers
            },
            body
        });

        let data = {} as T;
        try {
            data = await response.json();
        } catch (error) {
            // DO NOTHING
        }

        return {
            data,
            status: response.status
        };
    }

    async put(path: string, body: any): Promise<HttpClientResponse<T>> {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...this.headers
            },
            body: JSON.stringify(body)
        });

        let data = {} as T;
        try {
            data = await response.json();
        } catch (error) {
            // DO NOTHING
        }

        return {
            data,
            status: response.status
        };
    }

    async delete(path: string): Promise<HttpClientResponse<T>> {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'DELETE',
            headers: this.headers
        });

        let data = {} as T;
        try {
            data = await response.json();
        } catch (error) {
            // DO NOTHING
        }

        return {
            data,
            status: response.status
        };
    }

    async blob(path: string): Promise<HttpClientResponse<T>> {
        const response = await fetch(`${this.baseUrl}${path}`, {
            method: 'GET',
            headers: this.headers
        });

        return {
            data: {} as T,
            blob: response,
            status: response.status
        };
    }
}

export default HttpClient;
